interface ExtendedWindow extends Window {
  opera?: any;
}

declare const window: ExtendedWindow;

export const isMobileDevice = (): boolean =>
  /android|webos|iphone|blackberry|iemobile|ipad|ipod|opera mini/i.test(
    navigator.userAgent || navigator.vendor || window.opera || "",
  ) ||
  (navigator.userAgent.includes("Mac") && "ontouchend" in document);

export const isTabletDevice = (): boolean => {
  if (!isMobileDevice()) {
    return false;
  }

  const userAgent = (
    navigator.userAgent ||
    navigator.vendor ||
    window.opera ||
    ""
  ).toLowerCase();

  if (/ipad|tablet|playbook|silk|(android(?!.*mobile))/i.test(userAgent)) {
    return true;
  }

  if (
    navigator.userAgent.includes("Mac") &&
    "ontouchend" in document &&
    !/iphone|ipod/i.test(userAgent)
  ) {
    return true;
  }

  return window.innerWidth >= 1024;
};

export const getDeviceOrientation = () => {
  if (window.screen.orientation) {
    const orientationType = window.screen.orientation.type;

    if (orientationType.startsWith("portrait")) {
      return "portrait";
    } else if (orientationType.startsWith("landscape")) {
      return "landscape";
    }
  }

  const width = window.innerWidth;
  const height = window.innerHeight;

  return width > height ? "landscape" : "portrait";
};
